<div
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
  #trigger
  class="transparent-border-button"
  tabindex="0"
  role="button"
  [class.disabled]="isDisabled"
  [attr.aria-disabled]="isDisabled"
  (click)="togglePanel()"
  (keydown.enter)="$event.preventDefault(); togglePanel()"
>
  <i class="button-icon" [nimbusIcon]="icons.ADD_LIGHT"></i>
  <div class="button-text">
    {{ insertOperationName || (translations.SettingsFormAddButton | translate) }}
    <nimbus-tooltip [text]="insertOperationName || (translations.SettingsFormAddButton | translate)"></nimbus-tooltip>
  </div>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayLockPosition]="true"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="isPanelOpen"
  [cdkConnectedOverlayPositions]="cdkConnectedPositions"
  [cdkConnectedOverlayOffsetY]="offsetY"
  (positionChange)="onPositionChange($event)"
  (backdropClick)="close()"
  (attach)="onAttached()"
  (detach)="close()"
>
  <div
    class="nimbus-tooltip-complex editable-listbox-overlay-container mat-elevation-z4"
    [ngClass]="wrapperClasses$ | async"
    [@transformPanelWrap]
  >
    <div class="panel" #panel [@transformPanel]="'opened'" (@transformPanel.done)="panelDoneAnimatingStream.next($event.toState)">
      @if (!customSearchTemplate) {
        <nimbus-input-search [formControl]="searchInput"></nimbus-input-search>
      } @else {
        <ng-template [ngTemplateOutlet]="customSearchTemplate"></ng-template>
      }
      <div class="editable-listbox-item-container">
        @if (isLoading) {
          <nimbus-spinner></nimbus-spinner>
        }
        @for (item of filteredSet$ | async; track item.id) {
          <mat-option [disabled]="item['isDisabled']" (click)="addItem(item)">
            <ng-container *ngTemplateOutlet="selectableBodyTemplateRef; context: { item: item }"></ng-container>
          </mat-option>
        }
      </div>
    </div>
  </div>
</ng-template>
